export default __webpack_public_path__ + "static/intro-team-2-a2446efc62239273015e9f814185c952.jpg";